var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClinics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9753 84.3333H62.0247C70.8749 84.3333 78.0494 77.4869 78.0494 69.0413V50.3433C78.0494 47.6285 79.1795 45.0248 81.1912 43.1051C85.8521 38.6573 85.2462 31.2879 79.9154 27.5882L55.4253 10.5915C49.8062 6.69173 42.1938 6.69173 36.5748 10.5915L12.0846 27.5882C6.75385 31.2879 6.14794 38.6573 10.8088 43.1051C12.8205 45.0248 13.9507 47.6285 13.9507 50.3433V69.0413C13.9507 77.4869 21.1252 84.3333 29.9753 84.3333Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4167 55.2C59.4167 45.6731 46 34.5 46 34.5C46 34.5 32.5834 45.6731 32.5834 55.2C32.5834 64.7269 39.6487 69 46 69C52.3513 69 59.4167 64.7269 59.4167 55.2Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinics);
export default __webpack_public_path__ + "static/media/clinics.81e11164e667313d7d219f27db7c7f51.svg";
export { ForwardRef as ReactComponent };